import React, { useState, useEffect, useRef } from 'react';
import { Helmet } from 'react-helmet-async';
import Navbar from './Navbar';
import taxi from './belfast-cab-tour-home.png';
import tripadvisor from './tripadvisor.svg';
import checkmark from './check-mark.svg';
import muralPainting1 from '../assets/images/Beechmount_Avenue_1.jpg';
import muralPainting2 from '../assets/images/Beechmount_Avenue_2.jpg';
import muralPainting3 from '../assets/images/Bombay_Street_1.jpg';
import muralPainting4 from '../assets/images/Bombay_Street_2.jpg';
import muralPainting5 from '../assets/images/Divis_Flats.jpg';
import muralPainting6 from '../assets/images/Falls_Garden_Rememberance.jpg';
import muralPainting7 from '../assets/images/Garden_Rememberance_2.jpg';
import muralPainting8 from '../assets/images/Hawthorn_Street.jpg';
import muralPainting9 from '../assets/images/International_Wall_1.jpg';
import muralPainting10 from '../assets/images/International_Wall_2.jpg';
import muralPainting11 from '../assets/images/IRA_Plot_1.jpg';
import muralPainting12 from '../assets/images/IRA_Plot_2.jpg';
import muralPainting13 from '../assets/images/IRA_Plot_3.jpg';
import muralPainting14 from '../assets/images/IRA_Plot_4.jpg';
import muralPainting15 from '../assets/images/IRA_Plot_5.jpg';
import muralPainting16 from '../assets/images/IRA_Plot_6.jpg';
import muralPainting17 from '../assets/images/IRA_Plot_7.jpg';
import muralPainting18 from '../assets/images/IRA_Plot_8.jpg';
import muralPainting19 from '../assets/images/IRA_Plot_9.jpg';
import muralPainting20 from '../assets/images/James_Connolly_Visitor_Centre_1.jpg';
import muralPainting21 from '../assets/images/James_Connolly_Visitor_Centre_2.jpg';
import muralPainting22 from '../assets/images/James_Connolly_Plaque.jpg';
import muralPainting23 from '../assets/images/Oakman_Street.jpg';

import '../Styles.css';

const CheckmarkIcon = <img src={checkmark} alt="checkmark icon" className="checkmark-logo" />;

// 🔁 Slideshow images array
const muralImages = [
  muralPainting1,
  muralPainting2,
  muralPainting3,
  muralPainting4,
  muralPainting5,
  muralPainting6,
  muralPainting7,
  muralPainting8,
  muralPainting9,
  muralPainting10,
  muralPainting11,
  muralPainting12,
  muralPainting13,
  muralPainting14,
  muralPainting15,
  muralPainting16,
  muralPainting17,
  muralPainting18,
  muralPainting19,
  muralPainting20,
  muralPainting21,
  muralPainting22,
  muralPainting23,
];

function Home() {
  // State to store the current scroll position
  const [scrollTop, setScrollTop] = useState(0);

  const [currentMuralIndex, setCurrentMuralIndex] = useState(0);

  // Set up a scroll event listener to track scroll position
  useEffect(() => {
    const handleScroll = () => {
      setScrollTop(window.scrollY); // Get the scroll position
    };

    window.addEventListener('scroll', handleScroll); // Add event listener
    return () => {
      window.removeEventListener('scroll', handleScroll); // Clean up on component unmount
    };
  }, []);

    // 🔁 Slideshow auto-rotation
    useEffect(() => {
      const interval = setInterval(() => {
        setCurrentMuralIndex((prevIndex) =>
          (prevIndex + 1) % muralImages.length
        );
      }, 4000); // change every 4 seconds
  
      return () => clearInterval(interval);
    }, []);

    const videoRef = useRef(null);
const [soundEnabled, setSoundEnabled] = useState(false);

const handleUnmute = () => {
  const video = videoRef.current;
  if (!video) return;

  video.muted = false;
  video.volume = 1;

  video.play().catch(err => {
    console.error("Video play failed:", err);
  });

  setSoundEnabled(true);
};


  return (
    <div>
      <Navbar />
      <div className="Home-content-divider"><br /></div>
      <div className="Home-content-divider"><br /></div>
      <Helmet>
        <title>Belfast Black Taxi Tours | Peace Wall & Troubles History Cab Tours</title>
        <meta
          name="description"
          content="Explore Belfast's history on a black cab tour with local expert guides. Visit murals, Peace Walls, and key sites from the Troubles. Book today!"
        />
        <meta name="keywords" content="Belfast taxi tours, black cab tours Belfast, Troubles history tours, Peace Wall tours, Belfast murals, political tours Belfast, Giant's Causeway tours, Game of Thrones tours Northern Ireland" />
        <meta name="author" content="Belfast Cab Tour" />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://belfastcabtour.com" />
        
        {/* Open Graph tags for social media */}
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Belfast Black Taxi Tours | Peace Wall & Troubles History Cab Tours" />
        <meta property="og:description" content="Explore Belfast's history on a black cab tour with local expert guides. Visit murals, Peace Walls, and key sites from the Troubles. Book today!" />
        <meta property="og:url" content="https://belfastcabtour.com" />
        <meta property="og:image" content="https://belfastcabtour.com/belfast-cab-tour-home.png" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:site_name" content="Belfast Cab Tour" />
        <meta property="og:locale" content="en_GB" />
        
        {/* Twitter Card tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Belfast Black Taxi Tours | Peace Wall & Troubles History Cab Tours" />
        <meta name="twitter:description" content="Explore Belfast's history on a black cab tour with local expert guides. Visit murals, Peace Walls, and key sites from the Troubles. Book today!" />
        <meta name="twitter:image" content="https://belfastcabtour.com/belfast-cab-tour-home.png" />
        
        {/* Additional meta tags */}
        <meta name="geo.region" content="GB-NIR" />
        <meta name="geo.placename" content="Belfast" />
        <meta name="geo.position" content="54.5973;-5.9301" />
        <meta name="ICBM" content="54.5973, -5.9301" />
        
        {/* Language and region */}
        <meta httpEquiv="content-language" content="en-gb" />
        <meta name="language" content="English" />
      </Helmet>
      
      <Helmet>
        <script type="application/ld+json">
          {`
          {
            "@context": "https://schema.org",
            "@type": "LocalBusiness",
            "name": "Belfast Cab Tour",
            "image": "https://belfastcabtour.com/logo.png", 
            "url": "https://belfastcabtour.com",
            "telephone": "+447773600624",
            "priceRange": "£40-£150",
            "address": {
              "@type": "PostalAddress",
              "addressLocality": "Belfast",
              "addressRegion": "Northern Ireland",
              "addressCountry": "UK"
            },
            "openingHours": "Mo-Su 06:00-20:00",
            "aggregateRating": {
              "@type": "AggregateRating",
              "ratingValue": "4.9",
              "reviewCount": "134",
              "bestRating": "5",
              "worstRating": "1"
            },
            "sameAs": [
              "https://www.facebook.com/profile.php?id=61571319634353",
              "https://www.instagram.com/belfastcabtour",
              "https://www.tripadvisor.co.uk/Attraction_Review-g186470-d6214851-Reviews-Tours_By_Taxi_Belfast-Belfast_Northern_Ireland.html"
            ],
            "description": "Professional Belfast black taxi tours exploring the Troubles history, Peace Walls, political murals, and cultural sites with expert local guides.",
            "hasOfferCatalog": {
              "@type": "OfferCatalog",
              "name": "Belfast Taxi Tours",
              "itemListElement": [
                {
                  "@type": "Offer",
                  "itemOffered": {
                    "@type": "Service",
                    "name": "Political and Mural Tour",
                    "description": "Visit Protestant Shankill Road and Catholic Falls Road with expert guides"
                  }
                },
                {
                  "@type": "Offer",
                  "itemOffered": {
                    "@type": "Service",
                    "name": "Giant's Causeway Tour",
                    "description": "Scenic trips to Giant's Causeway and Antrim Coast"
                  }
                },
                {
                  "@type": "Offer",
                  "itemOffered": {
                    "@type": "Service",
                    "name": "Game of Thrones Tour",
                    "description": "Explore filming locations across Northern Ireland"
                  }
                }
              ]
            }
          }
          `}
        </script>
      </Helmet>

      {/* Header Section */}
      <header className="Home-header">
        <div className="animation-wrapper">
          <img
            src={taxi}
            className="taxi"
            alt="Belfast black taxi for historical tours"
            style={{
              top: '10%', // Adjust this value to raise the taxi
              transform: `translateY(-${scrollTop / 100}%)`, // Dynamic scroll effect
            }}
          />
        </div>
      </header>

      <div className="Home-content-divider"><br /></div>

      {/* Video Section */}
<div className="homepage-video-container">
  <div className="video-wrapper" style={{ position: "relative" }}>

    <video
      ref={videoRef}
      autoPlay
      muted
      playsInline
      preload="auto"
      controls
    >
      <source
        src="https://belfast-cab-tour-videos.s3.eu-north-1.amazonaws.com/Belfast_Cab_Tour_Virtual_Tour.mp4"
        type="video/mp4"
      />
      Your browser does not support the video tag.
    </video>

    {!soundEnabled && (
      <button
        onClick={handleUnmute}
        style={{
          position: "absolute",
          bottom: "20px",
          left: "50%",
          transform: "translateX(-50%)",
          padding: "10px 20px",
          fontSize: "16px",
          background: "rgba(0,0,0,0.7)",
          color: "#fff",
          border: "none",
          borderRadius: "5px",
          cursor: "pointer",
          zIndex: 10
        }}
      >
        🔊 Enable sound
      </button>
    )}

  </div>
</div>

      <div className="Home-content-divider"><br /></div>

      {/* Header Text */}
      <div className="header-container">
      <h1 className="Home-header1">
       <span className="header-line-1">Belfast Black Taxi Tours of The Troubles & Murals</span>
       <span className="header-line-2">Giant's Causeway Taxi Tours</span>
      </h1>
      </div>

      <div className="Home-content-divider"><br /></div>

      <section className="Home-book-now">
          <a href="tel:+447773600624" aria-label="Call Belfast Cab Tour to book your tour">
            <button className="call-button-home" id="call-button">
              Book Now - Call +44 7773 600624
            </button>
          </a>
      </section>

      <div className="Home-content-divider"><br /></div>

      {/* TripAdvisor Button */}
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        textAlign: 'center',
      }}>
        <a
          href="https://www.tripadvisor.co.uk/Attraction_Review-g186470-d6214851-Reviews-Tours_By_Taxi_Belfast-Belfast_Northern_Ireland.html"
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: 'none' }}
          aria-label="Visit our TripAdvisor page for Belfast taxi tour reviews"
        >
          <button style={{
            display: 'flex',
            alignItems: 'center',
            backgroundColor: '#00a680',
            border: 'none',
            borderRadius: '5px',
            padding: '5px 10px',
            color: 'white',
            fontSize: '16px',
            width: '230px',
            height: '45px',
            cursor: 'pointer',
            fontFamily: 'Arial, sans-serif',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
            transition: 'background-color 0.3s ease',
          }}>
            <img
              src={tripadvisor}
              alt="TripAdvisor Logo"
              style={{ width: '35px', height: '35px', marginRight: '10px' }}
            />
            <strong>Find us on TripAdvisor</strong>
          </button>
        </a>
      </div>

      <div className="Home-content-divider"><br /></div>

      <p className="international-wall-caption">
      Some of the sights you will see on our Belfast Murals Tour or Belfast Political Tour
      </p>

      {/* ✅ Slideshow replaces static image */}
      <div className="Home-content-mural-painting-home">
        <img
          src={muralImages[currentMuralIndex]}
          alt="Belfast political murals slideshow"
          className="mural-painting"
        />
      </div>

      <div className="Home-content-divider"><br /></div>

      <p className="video-caption">
      The Famous Belfast Bap at St. George's Market, Belfast
      </p>

      {/* Video Section */}
      <div className="homepage-video-container">
       <div className="video-wrapper">
        <video 
         controls 
         playsInline 
         muted 
         preload="auto"
         disablePictureInPicture
         controlsList="nodownload"
         webkit-playsinline="true"
         x5-playsinline="true"
         onLoadedData={(e) => {
          e.target.currentTime = 1; // Jump to 1 second to show a frame
        }}
        >
        <source
         src="https://belfast-cab-tour-videos.s3.eu-north-1.amazonaws.com/st-georges-market-belfast-bap.mp4"
         type="video/mp4"
        />
         Your browser does not support the video tag.
        </video>
       </div>
      </div>

      <div className="Home-content-divider"><br /></div>
      <div className="Home-content-divider"><br /></div>

      {/* Main Content */}
      <main className="Home-content">
        <section>
          <h2>
            WELCOME TO BELFAST CAB TOUR
          </h2>
          
          <p>
            Home of the original <strong>black taxi tours of Belfast</strong>. Our locally guided tours offer you a unique and powerful way to explore the complex history of Northern Ireland, from the days of <strong>The Troubles</strong> to today's vibrant culture. Join us on an unforgettable journey through political murals, historical landmarks, and deeply moving sites that tell the story of a city shaped by conflict and resilience.
          </p>

          <p>
            Our most popular tour is the <strong>Political and Mural Tour</strong>, where you'll visit both the Protestant Shankill Road and the Catholic Falls Road. Learn firsthand about the conflict from guides who lived through it – all from the comfort of our traditional black cabs. See iconic locations like the <strong>Peace Wall</strong>, Clonard Monastery, and memorial gardens. Hear the human stories behind the headlines, and take part in a meaningful, educational, and emotional experience.
          </p>

          <p>
            In addition to our political tours, we also offer scenic trips to the <strong>Giant's Causeway</strong>, <strong>Antrim Coast</strong>, and <strong>Game of Thrones filming locations</strong>. Whether you're a history enthusiast, a cultural explorer, or simply curious about Belfast's past, our tours are tailored to suit your interests and schedule.
          </p>

          <p>
            At Belfast Cab Tour, we pride ourselves on being passionate, knowledgeable, and respectful guides. With over 20 years of experience and hundreds of 5-star reviews on <strong>TripAdvisor</strong>, our team is committed to making your tour informative, safe, and unforgettable.
          </p>

          <p>
            Book your Belfast black taxi tour today and discover why we're one of the most recommended ways to experience Northern Ireland's history and heritage. Whether you're visiting for a day or a week, we guarantee a journey that stays with you for a lifetime.
          </p>
        </section>
      </main>

      <div className="Home-content-divider"><br /></div>

      <section className="Home-content1">
        <h2>Why Choose Our Belfast Taxi Tours?</h2>
        <ul>
          <li>
            {CheckmarkIcon}
            <span>
              <strong>Local Expertise:</strong> Our friendly drivers are knowledgeable guides who know Belfast inside out.
            </span>
          </li>
          <li>
            {CheckmarkIcon}
            <span>
              <strong>Customized Experiences:</strong> Choose from curated tours or create a bespoke journey tailored to your interests.
            </span>
          </li>
          <li>
            {CheckmarkIcon}
            <span>
              <strong>Comfort & Convenience:</strong> Travel in style and comfort with clean, modern vehicles designed for small groups and families.
            </span>
          </li>
          <li>
            {CheckmarkIcon}
            <span>
              <strong>Unbeatable Locations:</strong> From Titanic Belfast to the Peace Walls, we cover all the must-see spots.
            </span>
          </li>
        </ul>
      </section>

      <section className="Home-content2">
        <h3>Top-Rated Cab Tours in Belfast</h3>
        <ul>
          <li><strong>Belfast Political Taxi Tour:</strong> Learn about Northern Ireland's complex history and visit popular locations like the Falls Road and Shankill Road.</li>
          <li><strong>Giant's Causeway and Coastal Tour:</strong> Discover the breathtaking Antrim Coast and the legendary Giant's Causeway.</li>
          <li><strong>Game of Thrones Cab Tour:</strong> Explore filming locations across Northern Ireland.</li>
        </ul>

        <h3>Affordable Belfast Taxi Tours</h3>
        <p>
          Our tours offer exceptional value. Call us today for a quote tailored to your needs.
        </p>

        <h3>Book Your Belfast Cab Tour Today!</h3>
        <p>
          Don't miss out on the ultimate way to explore Belfast. Call us now to secure your spot!
        </p>
        <p>
          <a href="tel:+447773600624" aria-label="Call Belfast Cab Tour to book your tour">
            <button className="call-button-home" id="call-button">
              Book Now - Call +44 777 360 0624
            </button>
          </a>
        </p>
      </section>

      <section className='Socials-icons' aria-label="Follow us on social media">
        <a href="https://www.facebook.com/profile.php?id=61571319634353" target="_blank" rel="noopener noreferrer" aria-label="Follow Belfast Cab Tour on Facebook">
          <i className="fab fa-facebook" aria-hidden="true"></i>
        </a>
        <a href="https://www.instagram.com/belfastcabtour/?hl=en" target="_blank" rel="noopener noreferrer" aria-label="Follow Belfast Cab Tour on Instagram">
          <i className="fab fa-instagram" aria-hidden="true"></i>
        </a>
      </section>

      {/* Footer */}
      <footer style={{
        marginTop: 'auto',
        textAlign: 'center',
        padding: '1rem',
        backgroundColor: '#333',
        color: '#fff',
      }}>
        &copy; 2025 <a href="https://belfastcabtour.com" style={{ color: '#fff', textDecoration: 'none' }}>belfastcabtour.com</a>. All rights reserved.
      </footer>
    </div>
  );
}

export default Home;